import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { AlertIconSeverity } from './types';

@Component({
  selector: 'cf-frontend-sdk-alert-icon',
  templateUrl: './alert-icon.component.html',
  styleUrls: ['./styles/alert-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertIconComponent {
  public static readonly ICON_FAMILY = 'hui';
  public static readonly INFO_ICON = 'hui-info-circle';
  public static readonly INFO_OPEN_ICON = 'hui-info-circle-o';
  public static readonly SUCCESS_ICON = 'hui-check-circle';
  public static readonly SUCCESS_OPEN_ICON = 'hui-check-circle-o';
  public static readonly WARNING_ICON = 'hui-warning';
  public static readonly WARNING_OPEN_ICON = 'hui-warning-o';
  public static readonly ERROR_ICON = 'hui-close-circle';
  public static readonly ERROR_OPEN_ICON = 'hui-close-circle-o';

  /**
   * Severity determines which icon is displayed.
   */
  @Input()
  public severity: AlertIconSeverity | undefined;

  /**
   * Whether the icon should be an open variant.
   */
  @Input() public open = false;

  @HostBinding('class.cf-frontend-sdk-alert-icon') public alertIcon = true;

  @HostBinding('class')
  public get severityClass() {
    return `cf-frontend-sdk-alert-icon-${this.severity}`;
  }

  public get iconClass() {
    return `${AlertIconComponent.ICON_FAMILY} ${this.getIcon()}`;
  }

  private getIcon() {
    switch (this.severity) {
      case 'success': {
        return this.open ? AlertIconComponent.SUCCESS_OPEN_ICON : AlertIconComponent.SUCCESS_ICON;
      }
      case 'warning': {
        return this.open ? AlertIconComponent.WARNING_OPEN_ICON : AlertIconComponent.WARNING_ICON;
      }
      case 'error': {
        return this.open ? AlertIconComponent.ERROR_OPEN_ICON : AlertIconComponent.ERROR_ICON;
      }
      default:
        return this.open ? AlertIconComponent.INFO_OPEN_ICON : AlertIconComponent.INFO_ICON;
    }
  }
}
